import React from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { appState } from "$store";
import CField from "$forms/CField";
import ProjectSelect from "$forms/ProjectSelect";
import { useDockyardFormContext } from "../context/DockyardFormContext";
import { useDockyardStyles } from "../styles";

export const ProjectSection: React.FC = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const classes = useDockyardStyles();
  const { currentCompany, hasEdbLinked } = useDockyardFormContext();
  const { filter: sidebarCompanyFilter } = useSelector(appState);

  return (
    <div className={classes.newFormFieldsRow}>
      <CField
        control={control}
        disabled={hasEdbLinked}
        name="project"
        required
        error={errors.project}
      >
        {(props: any) => (
          <ProjectSelect
            {...props}
            companyId={
              sidebarCompanyFilter ? sidebarCompanyFilter._id : currentCompany
            }
            onChange={(projectId, project) => {
              props.onChange(projectId);
              setValue("contact", project?.contact?._id);
            }}
            required
            allowNoCompany={false}
          />
        )}
      </CField>
    </div>
  );
};
